export default function (theme) {
    return {
        MuiFab: {
            styleOverrides: {
                secondary: {
                    backgroundColor: theme.palette.secondary.dark,
                    color: theme.palette.secondary.contrastText
                },
                label: {
                    width: 'auto'
                },
                extended: {
                    minWidth: 160,
                    backgroundColor: theme.palette.primary.light,
                    color: theme.palette.primary.contrastText,
                    '&:hover': {
                        backgroundColor: theme.palette.primary.dark,
                        color: theme.palette.primary.contrastText
                    }
                }
            }
        }
    };
}